import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
    "model-value": _ctx.isShowLanguageTipTool,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "show-close": false,
    title: _ctx.data.title,
    width: "440px",
    center: ""
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
      onClick: _cache[0] || (_cache[0] = $event => _ctx.editCommon('cancel'))
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("取消")])),
      _: 1,
      __: [2]
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[1] || (_cache[1] = $event => _ctx.editCommon('sure'))
    }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("确定")])),
      _: 1,
      __: [3]
    })])]),
    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString('当前修改的数据属于:' + _ctx.data.name), 1)]),
    _: 1
  }, 8, ["model-value", "title"])]);
}